import adminHttp from "@/api/adminHttp";

export default {
    doubleEliminationGridGenerate: (stage, data) => adminHttp.post(`/api/v1/admin/tournament/double-elimination-grid-generate/${stage}`, data )
}